import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '@core/services/toast.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'drdp-edit-activity-bank',
  templateUrl: './edit-activity-bank.component.html',
  styleUrls: ['./edit-activity-bank.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditActivityBankComponent implements OnInit {
  descriptionForm: FormGroup | any;
  isSpanish = false;

  get description() {
    return this.descriptionForm.get('description');
  }

  get spanishDescription() {
    return this.descriptionForm.get('spanishDescription');
  }

  constructor(
    public dialogRef: MatDialogRef<EditActivityBankComponent>,
    private fb: FormBuilder,
    private toast: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translocoService: TranslocoService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.initializeForms();
  }

  initializeForms(): void {
    this.descriptionForm = this.fb.group({
      description: [null, [Validators.required]],
      spanishDescription: [null],
    });

    if (this.data) {
      this.descriptionForm.patchValue({
        description: this.data.description || null,
        spanishDescription: this.data.spanishDescription || null,
      });
    }
  }

  onSubmit(): any {
    if (this.descriptionForm.invalid) {
      this.toast.error(this.translocoService.translate('configuration.activityBank.form.descriptionRequiredToast'));
      return;
    }

    const payload = {
      activity: this.description.value,
      spanishActivity: this.spanishDescription.value
    };

    this.dialogRef.close({ formValid: true, payload: payload });
  }
}